export default "__VITE_ASSET__tnccYIOo__"